// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styles for deployment summary components */

/* Scrollable content area */
.summary-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
}

/* Screenshot header separator */
.summary-screenshot-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e5e5;
}

/* Intro paragraph */
.summary-intro-text {
  display: block;
  margin-bottom: 20px;
  color: #444;
  font-size: 14px;
  line-height: 1.6;
}

/* Three-column grid (rules per item) */
.summary-grid-three-col {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 250px));
  gap: 16px 32px;
}

/* Two-column grid (SITs + Labels) */
.summary-grid-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
}

/* Section label above a list */
.summary-section-label {
  font-weight: 600;
  font-size: 13px;
  display: block;
  margin-bottom: 6px;
  color: #333;
}

/* Generic list */
.summary-list {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
  color: #444;
}

/* Existing-items variant – slightly dimmer text */
.summary-list--existing {
  color: #555;
}

/* List item with icon + text */
.summary-list-item {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Header row containing an icon and a label */
.summary-icon-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

/* Footer row with Back / Cancel / Deploy buttons */
.summary-footer {
  display: flex;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #e5e5e5;
  background: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/policies/shared/summary.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD,4BAA4B;AAC5B;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sDAAsD;EACtD,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,kDAAkD;AAClD;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":["/* Shared styles for deployment summary components */\n\n/* Scrollable content area */\n.summary-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n}\n\n/* Screenshot header separator */\n.summary-screenshot-header {\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n/* Intro paragraph */\n.summary-intro-text {\n  display: block;\n  margin-bottom: 20px;\n  color: #444;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n/* Three-column grid (rules per item) */\n.summary-grid-three-col {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(180px, 250px));\n  gap: 16px 32px;\n}\n\n/* Two-column grid (SITs + Labels) */\n.summary-grid-two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 28px;\n}\n\n/* Section label above a list */\n.summary-section-label {\n  font-weight: 600;\n  font-size: 13px;\n  display: block;\n  margin-bottom: 6px;\n  color: #333;\n}\n\n/* Generic list */\n.summary-list {\n  margin: 0;\n  padding-left: 20px;\n  font-size: 13px;\n  color: #444;\n}\n\n/* Existing-items variant – slightly dimmer text */\n.summary-list--existing {\n  color: #555;\n}\n\n/* List item with icon + text */\n.summary-list-item {\n  margin-bottom: 4px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Header row containing an icon and a label */\n.summary-icon-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n/* Footer row with Back / Cancel / Deploy buttons */\n.summary-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 20px;\n  border-top: 1px solid #e5e5e5;\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
